import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IAdditionalSetting } from '@app/Models/IAdditionalSetting';
import { IListItem } from '@app/Models/IListItem';
import { TenantService } from '@app/Services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-list-items-import',
    templateUrl: './list-items-import.component.html',
    styleUrls: ['./list-items-import.component.scss'],
    imports: [MatSelect, FormsModule, MatOption]
})
export class ListItemsImportComponent implements OnInit, OnDestroy {
    @Input() setting: IAdditionalSetting;
    @Input() additionalValues = {};
    listItems: IListItem[];
    private isDestroyed$: Subject<void> = new Subject<void>();

    public constructor(private tenantService: TenantService){}

    ngOnInit(): void {
        if (this.listItemsHaveBeenPreLoaded()) {
            this.listItems = this.setting.ListItems;
        }
        else {
            this.initListItems();
        }
    }

    public isListItemsLoaded(): boolean{
        if(!this.listItems){
            return false;
        }

        return true;
    }

    ngOnDestroy(): void {
        this.isDestroyed$.next();
    }

    private listItemsHaveBeenPreLoaded() {
        return !!this.setting.ListItems && !this.setting.Values;
    }

    private initListItems(): void{
        this.tenantService
            .getListItems(this.setting.Values)
            .pipe(takeUntil(this.isDestroyed$))
            .subscribe(
                (listItems: IListItem[]) => {
                    this.listItems = listItems;
                });
    }
}